import type { PublicGovernmentResponse } from '@govinity/validation/public';
import { createContext, useContext } from 'react';

export const GovernmentContext = createContext<{
  government: PublicGovernmentResponse;
  invalidate: () => void;
  path: string;
}>({
  // hack to prevent having to check for null everywhere. We will check for null in the layout
  government: null as unknown as PublicGovernmentResponse,
  invalidate: () => {},
  path: '',
});

export function useGovernmentContext() {
  const context = useContext(GovernmentContext);

  if (context === undefined) {
    throw new Error('useGovernmentContext must be used within a GovernmentContext.Provider');
  }

  return context;
}
